interface NavBarProps{
    name: string;
    activeLink: string;
    inactiveLink: string;
}

export const navBarData: NavBarProps[] = [
    {
        name: 'dashboard',
        activeLink: './images/nav/active-dashboard.svg',
        inactiveLink: './images/nav/inactive-dashboard.svg'
    },
    {
        name: 'tank',
        activeLink: './images/nav/active-tank.svg',
        inactiveLink: './images/nav/inactive-tank.svg'
    },
    {
        name: 'user',
        activeLink: './images/nav/active-user.svg',
        inactiveLink: './images/nav/inactive-user.svg'
    }
]